var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base_objects',{ref:"objects",attrs:{"essence":"ОА","service":_vm.service,"single_element_url":"analogues","with_delete_many":"","with_group":"","keys_if_all_attrs_hidden":_vm.default_attrs,"essence_name_many":'объекты-аналоги'}})
}
var staticRenderFns = []

export { render, staticRenderFns }